import {
  Box,
  Card,
  Checkbox,
  Divider,
  FormControlLabel,
  List,
  ListItem,
  ListItemSecondaryAction,
  Typography,
} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spinner } from 'reactstrap';

import Breadcrumb from '@/components/common/breadcrumb.component';
import { Constants } from '@/constants';

const hashids = new Hashids('', 12);

const RoleDetailsView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loadingRole, setLoadingRole] = useState(false);
  const [saving, setSaving] = useState(false);
  const [role, setRole] = useState({});

  useEffect(() => {
    let decodedId: number | undefined;
    try {
      const decoded = hashids.decode(id || '');
      if (decoded && decoded.length > 0 && typeof decoded[0] === 'number') {
        decodedId = decoded[0] as number;
      }
    } catch {
      decodedId = undefined;
    }

    if (decodedId) {
      axios
        .get(`${Constants.apiPath}/roles/${decodedId}`)
        .then((res) => {
          setRole(res.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => setLoadingRole(false));
    }
  }, [id]);

  const handleToggle = (groupKey, field) => {
    setRole((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        permissions: prev.permissions.map((perm) =>
          perm.key === groupKey ? { ...perm, [field]: !perm[field] } : perm
        ),
      };
    });
  };

  const saveRole = () => {
    // TODO
  };

  if (loadingRole) {
    return (
      <div>
        <Breadcrumb title="Role Details" label="Roles" parent="Roles" />
        <div className="container-fluid">
          <Typography variant="body1" sx={{ mt: 4, textAlign: 'center' }}>
            Loading role…
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb title={role.name} label="Roles" parent="Roles" />

      <div className="container-fluid">
        <div
          style={{
            maxWidth: 800,
            width: '100%',
            margin: '30px auto',
          }}
        >
          <Card
            style={{
              maxWidth: 1200,
              width: '100%',
              margin: '30px auto',
              padding: 20,
            }}
          >
            <Box mb={2}>
              <Typography variant="h6">{role.name}</Typography>
              {role.description && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mt: 0.5 }}
                >
                  {role.description}
                </Typography>
              )}
            </Box>

            <Divider />

            <Box
              display="flex"
              justifyContent="space-between"
              px={2}
              py={1}
              sx={{ fontWeight: 500, color: 'text.secondary' }}
            >
              <span>Action Group</span>
              <span>Permissions</span>
            </Box>

            {role.permissions && role.permissions.length > 0 && (
              <List>
                {role.permissions.map((perm) => (
                  <ListItem key={perm.key} divider>
                    <ListItemText primary={perm.name} secondary={perm.key} />
                    <ListItemSecondaryAction>
                      <Box display="flex" alignItems="center" gap={1}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!perm.can_read}
                              onChange={() =>
                                handleToggle(perm.key, 'can_read')
                              }
                            />
                          }
                          label="Read"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!perm.can_write}
                              onChange={() =>
                                handleToggle(perm.key, 'can_write')
                              }
                            />
                          }
                          label="Write"
                        />
                      </Box>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}
            <Button
              onClick={saveRole}
              variant="contained"
              color="primary"
              disabled={saving}
              style={{ float: 'right' }}
            >
              {saving && (
                <Spinner color="dark" style={{ marginRight: 8 }} size="sm" />
              )}
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RoleDetailsView;
